import { isValueStringType } from '../../../../utils/common'

export function isEditableElement(element) {
  if (!element) {
    return false
  }

  const isHTMLElement =
    typeof HTMLElement !== 'undefined' && element instanceof HTMLElement

  if (isHTMLElement && element.isContentEditable) {
    return true
  }

  const tagName = element.tagName

  if (!isValueStringType(tagName)) {
    return false
  }

  return tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT'
}
